import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2" }
const _hoisted_2 = { class: "default_card_wm pt-2" }
const _hoisted_3 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_4 = ["viewBox"]
const _hoisted_5 = ["xlink:href", "height", "width"]
const _hoisted_6 = ["points", "onClick"]
const _hoisted_7 = ["points", "onMouseover", "onMouseout", "onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-error"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ml-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "ml-3" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  "data-cy": "DocumentValidation-%tva"
}
const _hoisted_24 = { class: "inline-icon" }
const _hoisted_25 = { class: "text-red" }
const _hoisted_26 = { id: "ValidDocumentValidation" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_AccountableAccountVue = _resolveComponent("AccountableAccountVue")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_DocumentAuditActions = _resolveComponent("DocumentAuditActions")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_DocumentAdjustments = _resolveComponent("DocumentAdjustments")!
  const _component_StockOperationDocumentEdition = _resolveComponent("StockOperationDocumentEdition")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_DocumentValidationSpeedRun = _resolveComponent("DocumentValidationSpeedRun")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          class: "pr-1",
          cols: _ctx.accountingLinesLocked ? 7 : 6
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DocumentMenu, {
                selectedText: _ctx.selectedText,
                "onUpdate:selectedText": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedText) = $event)),
                MenuOptions: _ctx.documentMenuOptions,
                onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back())),
                onZoomOut: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomManager.zoomOut())),
                onResetZoom: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomManager.resetZoom())),
                onZoomIn: _cache[4] || (_cache[4] = ($event: any) => (_ctx.zoomManager.zoomIn())),
                onOcrChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onOCRChanged())),
                onRotateLeft: _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('left', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                onRotateRight: _cache[7] || (_cache[7] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('right', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                onClearSelectedText: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emptySelectedText())),
                onEdit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.accountingLinesLockedDialog = true)),
                onDisplayFile: _cache[10] || (_cache[10] = ($event: any) => {
                            _ctx.showAccountingLines = false;
                            _ctx.displayActivity = false;
                        }),
                onDisplayAccountingLine: _cache[11] || (_cache[11] = ($event: any) => {
                            _ctx.showAccountingLines = true;
                            _ctx.displayActivity = false;
                        }),
                onDownload: _cache[12] || (_cache[12] = ($event: any) => (_ctx.startDownloadFile())),
                onCut: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cutDocumentDialog = true)),
                onAnalyse: _cache[14] || (_cache[14] = ($event: any) => (_ctx.analyseDocumentDialog = true)),
                onActivity: _cache[15] || (_cache[15] = ($event: any) => {
                            _ctx.displayActivity = true;
                            _ctx.showAccountingLines = false;
                        }),
                onDelete: _cache[16] || (_cache[16] = ($event: any) => (
                            _ctx.orphelinDepreciationAcrId?.length
                                ? (_ctx.deleteOrphelinDocumentDialog = true)
                                : (_ctx.deleteDocumentDialog = true)
                        ))
              }, null, 8, ["selectedText", "MenuOptions"]),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "align-center"
              }, {
                default: _withCtx(() => [
                  (!_ctx.displayActivity && !_ctx.showAccountingLines)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.isImage)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12",
                              style: {"max-height":"86vh","overflow-y":"auto"},
                              id: "InvoiceDocumentValidation"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  (_ctx.document)
                                    ? (_openBlock(), _createElementBlock("svg", {
                                        key: 0,
                                        id: "svg-document-validation",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "100%",
                                        viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                        style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                      }, [
                                        _createElementVNode("g", null, [
                                          _createElementVNode("image", {
                                            id: "svg-image-document-validation",
                                            "xlink:href": _ctx.document.signedUrl,
                                            x: "0",
                                            y: "0",
                                            height: `${_ctx.imageHeight}px`,
                                            width: `${_ctx.imageWidth}px`
                                          }, null, 8, _hoisted_5),
                                          (!_ctx.showOCR)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.svgVariants, (variant, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: `coord-${_ctx.document.id}-${index}`
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.coordinates, (coord, index2) => {
                                                    return (_openBlock(), _createElementBlock("polygon", {
                                                      key: `coord-${_ctx.document.id}-${index}-${index2}`,
                                                      ref_for: true,
                                                      ref: `variants-${index}-${index2}`,
                                                      points: _ctx.getPoints(coord),
                                                      style: _normalizeStyle(
                                                                variant.active
                                                                    ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                    : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                            ),
                                                      onClick: _withModifiers(($event: any) => (
                                                                variant.active
                                                                    ? ''
                                                                    : _ctx.showCorrespondingField({
                                                                          variant,
                                                                          currentIndex: index,
                                                                          copyIndex: index2,
                                                                      })
                                                            ), ["stop"]),
                                                      class: _normalizeClass(
                                                                variant.focus ? 'highlighted' : ''
                                                            )
                                                    }, null, 14, _hoisted_6))
                                                  }), 128))
                                                ], 64))
                                              }), 128))
                                            : (
                                                    _ctx.showOCR &&
                                                    _ctx.ocr &&
                                                    _ctx.ocr.sentences &&
                                                    _ctx.ocr.sentences.length
                                                )
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.ocr.sentences, (sentence, sIndex) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                                    key: `sentence-${sIndex}`
                                                  }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentence.tokens, (token, tIndex) => {
                                                      return (_openBlock(), _createElementBlock("polygon", {
                                                        key: `sentence-${sIndex}-token-${tIndex}`,
                                                        ref_for: true,
                                                        ref: `sentence-${sIndex}-token-${tIndex}`,
                                                        points: _ctx.getTokenPoints(token),
                                                        style: _normalizeStyle(_ctx.getTokenStyle(token)),
                                                        onMouseover: ($event: any) => (token.high = true),
                                                        onMouseout: ($event: any) => (token.high = false),
                                                        onClick: _withModifiers(($event: any) => (_ctx.onClickToken(token)), ["stop"])
                                                      }, null, 44, _hoisted_7))
                                                    }), 128))
                                                  ], 64))
                                                }), 128))
                                              : _createCommentVNode("", true)
                                        ])
                                      ], 8, _hoisted_4))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }))
                          : (_ctx.isPDF)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "12",
                                class: "d-flex justify-center",
                                style: {"height":"calc(100vh - 130px)","overflow-y":"auto"},
                                id: "InvoiceDocumentValidation"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ossPdf, {
                                    documentId: _ctx.document.id,
                                    rotation: _ctx.documentPdfRotation,
                                    "onUpdate:rotation": _ctx.updateRotation
                                  }, null, 8, ["documentId", "rotation", "onUpdate:rotation"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.displayActivity && !_ctx.showAccountingLines)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        cols: "12",
                        style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UsersActivitiesHistory, {
                            documentId: _ctx.document.id
                          }, null, 8, ["documentId"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.displayActivity && _ctx.showAccountingLines)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 2,
                        cols: "12",
                        style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_accounting_item_static, {
                            companyId: _ctx.companyId,
                            documentId: _ctx.document.id,
                            mode: "Embedded"
                          }, null, 8, ["companyId", "documentId"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            (_ctx.associatedFields.show)
              ? (_openBlock(), _createBlock(_component_v_list, {
                  key: 0,
                  style: _normalizeStyle(_ctx.svgPosition)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: `field-${_ctx.document.id}-${key}-${index}`,
                        onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                        class: "oss-list-item"
                      }, null, 8, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: _ctx.accountingLinesLocked ? 5 : 6,
          class: "my-0 pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important"},
              class: "default_card_wm elevation-0 rounded-l-2 fill-height",
              id: "FormDocumentValidation"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, {
                  class: "px-0",
                  style: {"height":"calc(100vh - 140px)","overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.windowStep,
                      "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.windowStep) = $event)),
                      touchless: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: 0 }, {
                          default: _withCtx(() => [
                            (_ctx.form.date)
                              ? (_openBlock(), _createBlock(_component_v_form, {
                                  key: 0,
                                  ref: "form",
                                  modelValue: _ctx.valid,
                                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.valid) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, {
                                              "single-line": "",
                                              class: "pt-0",
                                              density: "compact"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item, {
                                                  ripple: false,
                                                  class: "oss-list-item mb-2",
                                                  color: "success"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "3",
                                                              class: "d-flex align-center",
                                                              style: {"border-right":"1px #ededed solid"}
                                                            }, {
                                                              default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                                _createElementVNode("b", null, "Statut", -1)
                                                              ])),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, {
                                                              cols: "9",
                                                              class: "d-flex align-center pl-2"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.documentStatus) + " ", 1),
                                                                _createVNode(_component_v_spacer)
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          id: "ThirdCompanyDocumentValidation"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                              class: "default_card_wm mx-auto pt-2",
                                              style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"},
                                              "data-cy": "DocumentValidation-societe"
                                            }, {
                                              default: _withCtx(() => [
                                                (!_ctx.consumer)
                                                  ? (_openBlock(), _createBlock(_component_v_card_title, {
                                                      key: 0,
                                                      "primary-title": "",
                                                      class: "py-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "11" }, {
                                                              default: _withCtx(() => [
                                                                (
                                                                    _ctx.document.thirdPartyCompany &&
                                                                    _ctx.document.thirdPartyCompany.id
                                                                )
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                      _createTextVNode(_toDisplayString(_ctx.thirdPartyType() +
                                                                    ": " +
                                                                    (_ctx.document.thirdPartyCompany
                                                                        ? _ctx.document.thirdPartyCompany
                                                                              .name
                                                                        : "")), 1)
                                                                    ], 64))
                                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                      (
                                                                        _ctx.isBankTransactionReceipt ||
                                                                        _ctx.isIncomingOutgoingPayment ||
                                                                        _ctx.isExpenseReportDocument
                                                                    )
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Sélectionnez une société (Facultatif) "))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_9, " Sélectionnez une société "))
                                                                    ], 64))
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, {
                                                              cols: "1",
                                                              class: "d-flex justify-end"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (!_ctx.consumer)
                                                                  ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                      key: 0,
                                                                      icon: "$oss-edit",
                                                                      elevation: "0",
                                                                      class: "my-0",
                                                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.windowStep = 1)),
                                                                      "data-cy": "DocumentValidation-fournisseur",
                                                                      size: "small"
                                                                    }))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                _createVNode(_component_v_card_text, { class: "text-left" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, { cols: "8" }, {
                                                          default: _withCtx(() => [
                                                            (
                                                                    !_ctx.consumer &&
                                                                    _ctx.document.thirdPartyCompany &&
                                                                    _ctx.document.thirdPartyCompany.siret
                                                                )
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Siret : " + _toDisplayString(_ctx.getSiretValue(
                                                                        _ctx.document.thirdPartyCompany
                                                                            .siret,
                                                                    )), 1))
                                                              : _createCommentVNode("", true),
                                                            (_ctx.fullAddress)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Adresse : " + _toDisplayString(_ctx.fullAddress), 1))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "4",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (
                                                                    _ctx.document.type ===
                                                                    'SALES_INVOICE'
                                                                )
                                                              ? (_openBlock(), _createBlock(_component_v_switch, {
                                                                  key: 0,
                                                                  modelValue: _ctx.consumer,
                                                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.consumer) = $event)),
                                                                  class: "my-0",
                                                                  label: 'Particulier',
                                                                  "hide-details": ""
                                                                }, null, 8, ["modelValue"]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        (
                                                                _ctx.document?.thirdPartyCompany &&
                                                                !_ctx.document?.thirdPartyCompany
                                                                    .isActive
                                                            )
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 0,
                                                              cols: "12"
                                                            }, {
                                                              default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                                _createElementVNode("p", { class: "text-red" }, " Cette société est inactive ", -1)
                                                              ])),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          id: "NameDocumentValidation"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              modelValue: _ctx.document.displayName,
                                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.document.displayName) = $event)),
                                              label: "Nom du document",
                                              "hide-details": "",
                                              density: "compact"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (
                                            _ctx.activateTagguing &&
                                            _ctx.document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 0,
                                          "no-gutters": "",
                                          class: "pt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item, {
                                                  ripple: false,
                                                  class: "oss-list-item mb-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_FreeTag, {
                                                                  companyTags: _ctx.allCompanyTags,
                                                                  document: _ctx.inDocument,
                                                                  splitUserPartitions: true,
                                                                  onOnTagsChanged: 
                                                                    _ctx.startToBeDoneIfNecessary
                                                                
                                                                }, null, 8, ["companyTags", "document", "onOnTagsChanged"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "pr-1",
                                          id: "TypeDocumentValidation"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_select_filled, {
                                              items: _ctx.documentTypes,
                                              "item-value": "value",
                                              label: "Type",
                                              style: {"margin":"0 auto"},
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (
                                                    _ctx.onTypeChange(
                                                        $event.toUpperCase().replace(' ', '_'),
                                                    )
                                                )),
                                              "hide-details": "",
                                              "model-value": _ctx.document.type,
                                              "item-title": (item) => item.label
                                            }, null, 8, ["items", "model-value", "item-title"])
                                          ]),
                                          _: 1
                                        }),
                                        (
                                                _ctx.document.type === 'CURRENT_ACCOUNT' ||
                                                _ctx.document.type === 'OPERATOR_ACCOUNT'
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "12",
                                              class: "pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select_filled, {
                                                  items: _ctx.currentAccountUsers,
                                                  "item-title": _ctx.getUserDisplayName,
                                                  "item-value": "id",
                                                  label: "Associé",
                                                  style: {"margin":"0 auto"},
                                                  modelValue: _ctx.currentAccountUser,
                                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.currentAccountUser) = $event)),
                                                  "return-object": "",
                                                  "hide-details": "",
                                                  rules: _ctx.currentAccountUserRules,
                                                  error: !_ctx.checkCurrentAccountUser,
                                                  density: "compact"
                                                }, null, 8, ["items", "item-title", "modelValue", "rules", "error"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, {
                                          class: "d-flex align-center justify-end px-1",
                                          id: "CreditNoteDocumentValidation",
                                          "data-cy": "DocumentValidation-credit"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              "hide-details": "",
                                              modelValue: _ctx.document.creditNote,
                                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.document.creditNote) = $event)),
                                              label: 'Avoir',
                                              class: "my-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pt-2",
                                      id: "DatesDocumentValidation"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { class: "pr-1" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_combobox_filled, {
                                              modelValue: _ctx.formattedDate,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formattedDate) = $event)),
                                              color: 
                                                    _ctx.form.date && _ctx.form.date.validated ? '' : 'red'
                                                ,
                                              items: _ctx.dateList,
                                              error: !_ctx.form.date || !_ctx.form.date.validated,
                                              class: "small-prepend-icon",
                                              onKeyup: _cache[25] || (_cache[25] = _withKeys(($event: any) => (
                                                    _ctx.onDateChange(_ctx.form.date, 'date', $event)
                                                ), ["enter"])),
                                              onMouseover: _cache[26] || (_cache[26] = ($event: any) => (_ctx.highlightField(_ctx.form.date, true))),
                                              onMouseout: _cache[27] || (_cache[27] = ($event: any) => (_ctx.highlightField(_ctx.form.date, false))),
                                              "onUpdate:search": _cache[28] || (_cache[28] = ($event: any) => (_ctx.formattedDate = $event)),
                                              required: "",
                                              dense: "",
                                              "hide-details": ""
                                            }, {
                                              "prepend-inner": _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  style: {"z-index":"1"},
                                                  class: "ml-2 mt-1",
                                                  onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.dateDialog = !_ctx.dateDialog), ["stop"]))
                                                }, {
                                                  default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                    _createTextVNode("$oss-calendar")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              label: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_12, [
                                                  _cache[107] || (_cache[107] = _createTextVNode(" Date du document ")),
                                                  (_ctx.confidence(_ctx.form.date))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                        _cache[105] || (_cache[105] = _createTextVNode(" ( ")),
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass(
                                                                    _ctx.confidence(_ctx.form.date) > 80
                                                                        ? ''
                                                                        : 'text-red'
                                                                )
                                                        }, _toDisplayString(`${_ctx.confidence(_ctx.form.date)}%`), 3),
                                                        _cache[106] || (_cache[106] = _createTextVNode(") "))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "color", "items", "error"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "1",
                                          class: "d-flex justify-start"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                                    _ctx.form.date && _ctx.form.date.validated
                                                        ? '$oss-circle-check'
                                                        : '$oss-circle-uncheck'
                                                ,
                                              color: 
                                                    _ctx.form.date && _ctx.form.date.validated
                                                        ? 'primary'
                                                        : 'red'
                                                ,
                                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.validateDateField(_ctx.form.date, 'date'))),
                                              size: "small"
                                            }, null, 8, ["icon", "color"])
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.dueDateEnable)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              class: "px-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  modelValue: _ctx.dueDate,
                                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.dueDate) = $event)),
                                                  "hide-details": true,
                                                  label: _ctx.$t('shared.dueDate'),
                                                  onChangeDate: _ctx.onDueDateChanged,
                                                  mandatory: false,
                                                  textFieldReadOnly: false,
                                                  prefixDataCy: 'DocumentValidation-dueDate-'
                                                }, null, 8, ["modelValue", "label", "onChangeDate"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.documentIsInAccountingClosing)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              class: "px-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  modelValue: _ctx.accountingDate,
                                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.accountingDate) = $event)),
                                                  "hide-details": true,
                                                  label: _ctx.$t('shared.accountingDate'),
                                                  mandatory: true,
                                                  textFieldReadOnly: false,
                                                  prefixDataCy: 'DocumentValidation-accountingDate-'
                                                }, null, 8, ["modelValue", "label"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "11",
                                          class: "pr-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_combobox_filled, {
                                              modelValue: _ctx.invoiceNumber,
                                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.invoiceNumber) = $event)),
                                              items: _ctx.invoiceNumberList,
                                              color: 
                                                    _ctx.form['invoiceNumber'].validated ? '' : 'red'
                                                ,
                                              error: !_ctx.form['invoiceNumber'].validated,
                                              onKeyup: _cache[33] || (_cache[33] = _withKeys(($event: any) => (
                                                    _ctx.onDateChange(
                                                        _ctx.form['invoiceNumber'],
                                                        'invoiceNumber',
                                                        $event,
                                                    )
                                                ), ["enter"])),
                                              onMouseover: _cache[34] || (_cache[34] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form['invoiceNumber'], true)
                                                )),
                                              onMouseout: _cache[35] || (_cache[35] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form['invoiceNumber'], false)
                                                )),
                                              "onUpdate:search": _cache[36] || (_cache[36] = ($event: any) => (_ctx.invoiceNumber = $event)),
                                              mandatory: _ctx.isInvoiceNumberManadatory,
                                              dense: "",
                                              "hide-details": true,
                                              "data-cy": "DocupmentValidation-numInvoice"
                                            }, {
                                              "prepend-inner": _withCtx(() => _cache[108] || (_cache[108] = [
                                                _createElementVNode("div", { class: "ml-1" }, null, -1)
                                              ])),
                                              label: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_14, [
                                                  _cache[111] || (_cache[111] = _createTextVNode(" Numéro de facture ")),
                                                  (_ctx.confidence(_ctx.form['invoiceNumber']))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                        _cache[109] || (_cache[109] = _createTextVNode(" (")),
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass(
                                                                    _ctx.confidence(
                                                                        _ctx.form['invoiceNumber'],
                                                                    ) > 80
                                                                        ? ''
                                                                        : 'text-red'
                                                                )
                                                        }, _toDisplayString(`${_ctx.confidence(
                                                                        _ctx.form["invoiceNumber"],
                                                                    )}%`), 3),
                                                        _cache[110] || (_cache[110] = _createTextVNode(") "))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "items", "color", "error", "mandatory"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "1",
                                          class: "d-flex justify-start"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                                    _ctx.form['invoiceNumber'] &&
                                                    _ctx.form['invoiceNumber'].validated
                                                        ? '$oss-circle-check'
                                                        : '$oss-circle-uncheck'
                                                ,
                                              color: 
                                                    _ctx.form['invoiceNumber'].validated
                                                        ? 'primary'
                                                        : 'red'
                                                ,
                                              onClick: _cache[37] || (_cache[37] = ($event: any) => (
                                                    _ctx.form['invoiceNumber'].validated =
                                                        !_ctx.form['invoiceNumber'].validated
                                                )),
                                              size: "small"
                                            }, null, 8, ["icon", "color"])
                                          ]),
                                          _: 1
                                        }),
                                        (!_ctx.multiAccountableAccount)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: 
                                                _ctx.stockOperation && _ctx.stockOperation.stockProductId
                                                    ? 8
                                                    : 12
                                            ,
                                              class: "pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_AccountableAccountVue, {
                                                  companyId: _ctx.companyId,
                                                  document: _ctx.document,
                                                  inputStyle: 'padding: 0px; margin: 0px;',
                                                  showSuggestion: false,
                                                  showDescription: true,
                                                  showValidation: false,
                                                  mandatory: false,
                                                  hideDetails: true,
                                                  editAccountableAccount: true,
                                                  addInvoiceProduct: _ctx.enableStock,
                                                  onClose: _ctx.closeAccountableAccount,
                                                  onSelectAccountableAccount: 
                                                    _ctx.selectAccountableAccount
                                                ,
                                                  innerId: "AccountableAccountDocumentValidation",
                                                  id: "AccountableAccountDocumentValidation",
                                                  "data-cy": "DocumentValidation-AccountableAccountVue"
                                                }, null, 8, ["companyId", "document", "addInvoiceProduct", "onClose", "onSelectAccountableAccount"])
                                              ]),
                                              _: 1
                                            }, 8, ["cols"]))
                                          : _createCommentVNode("", true),
                                        (
                                                !_ctx.multiAccountableAccount &&
                                                _ctx.stockOperation &&
                                                _ctx.stockOperation.stockProductId
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 1,
                                              cols: "4",
                                              class: "pl-2 pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": true,
                                                  label: "Quantité de produit",
                                                  class: "ml-2 righted-input",
                                                  modelValue: _ctx.stockOperation.productQuantity,
                                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.stockOperation.productQuantity) = $event)),
                                                  rules: [
                                                    (v) => v > 0 || _ctx.$t('settings.positiveNumber'),
                                                ]
                                                }, null, 8, ["modelValue", "rules"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.stockOperation && _ctx.stockOperation.data)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.stockOperation.data.quantities, (item, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (index % 4 === 0)
                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                  key: 0,
                                                  "no-gutters": "",
                                                  class: "pt-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                        (
                                                            _ctx.stockOperation.data.quantities[
                                                                index + i - 1
                                                            ]
                                                        )
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              cols: "3",
                                                              key: index + i
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_oss_text_field_filled, {
                                                                  "hide-details": true,
                                                                  label: 
                                                                _ctx.stockOperation.data.quantities[
                                                                    index + i - 1
                                                                ].quantityName
                                                            ,
                                                                  class: _normalizeClass(
                                                                (i > 1 ? 'ml-2 ' : '') +
                                                                'righted-input oss-dark'
                                                            ),
                                                                  modelValue: 
                                                                _ctx.stockOperation.data.quantities[
                                                                    index + i - 1
                                                                ].quantity
                                                            ,
                                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                _ctx.stockOperation.data.quantities[
                                                                    index + i - 1
                                                                ].quantity
                                                            ) = $event),
                                                                  rules: [
                                                                (v) =>
                                                                    v >= 0 ||
                                                                    _ctx.$t('settings.positiveNumber'),
                                                            ]
                                                                }, null, 8, ["label", "class", "modelValue", "onUpdate:modelValue", "rules"])
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 64))
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 256))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-2 pt-5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "1",
                                          class: "d-flex align-center flex-grow-1 flex-shrink-0",
                                          style: {"max-width":"100%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.subjectToVAT
                                                    ? _ctx.document.type === "SALES_INVOICE"
                                                        ? "TVA et comptes de charges"
                                                        : "TVA"
                                                    : "Montant"), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "11",
                                          class: "d-flex align-center flex-grow-0 flex-shrink-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pb-5"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.subjectToVAT)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "4",
                                              class: "d-flex align-center pl-1",
                                              id: "MultiVATDocumentValidation"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_switch, {
                                                  modelValue: _ctx.multiVat,
                                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.multiVat) = $event)),
                                                  label: "Multi TVA",
                                                  "hide-details": "",
                                                  disabled: _ctx.disabledMultiVat,
                                                  class: "my-0 pl-2"
                                                }, null, 8, ["modelValue", "disabled"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex align-center pl-1",
                                          id: "MultiAccountableAccountDocumentValidation"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              modelValue: _ctx.multiAccountableAccount,
                                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.multiAccountableAccount) = $event)),
                                              label: "Multi comptes comptable",
                                              "hide-details": "",
                                              class: "my-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.multiAccountableAccount || _ctx.multiVat)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 1,
                                              cols: _ctx.subjectToVAT ? '2' : '6',
                                              class: "d-flex align-center justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                  icon: "$add",
                                                  size: "x-small",
                                                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.addNewSubAmount()))
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["cols"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.multiVat || _ctx.multiAccountableAccount)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.form.subAmounts, (subAmount, index) => {
                                          return (_openBlock(), _createBlock(_component_v_row, {
                                            "no-gutters": "",
                                            key: index,
                                            class: "subAmountLine pt-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(subAmount.sign === -1 ? "Remise" : ""), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, { cols: "11" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        class: "py-1 pr-1",
                                                        cols: 
                                                            !_ctx.multiVat
                                                                ? subAmount.stockOperation &&
                                                                  subAmount.stockOperation
                                                                      .stockProductId
                                                                    ? '4'
                                                                    : '6'
                                                                : ''
                                                        
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_text_field_filled, {
                                                            regular: "",
                                                            dense: "",
                                                            "hide-details": true,
                                                            "onUpdate:modelValue": [($event: any) => (
                                                                _ctx.$nextTick(() =>
                                                                    _ctx.onMetadataChange_amountData(
                                                                        subAmount,
                                                                        'netAmount',
                                                                    ),
                                                                )
                                                            ), ($event: any) => ((subAmount.netAmount.value) = $event)],
                                                            onMouseover: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.netAmount,
                                                                    true,
                                                                )
                                                            ),
                                                            onMouseout: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.netAmount,
                                                                    false,
                                                                )
                                                            ),
                                                            color: 
                                                                _ctx.priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            ,
                                                            modelValue: subAmount.netAmount.value
                                                          }, {
                                                            label: _withCtx(() => [
                                                              _createTextVNode(" HT " + _toDisplayString(index + 1) + " ", 1),
                                                              (
                                                                        _ctx.confidence(
                                                                            subAmount.netAmount,
                                                                        )
                                                                    )
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                                                    _cache[112] || (_cache[112] = _createTextVNode(" (")),
                                                                    _createElementVNode("span", {
                                                                      class: _normalizeClass(
                                                                            _ctx.confidence(
                                                                                subAmount.netAmount,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        )
                                                                    }, _toDisplayString(`${_ctx.confidence(
                                                                                subAmount.netAmount,
                                                                            )}%`), 3),
                                                                    _cache[113] || (_cache[113] = _createTextVNode(") "))
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onUpdate:modelValue", "onMouseover", "onMouseout", "color", "modelValue"])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["cols"]),
                                                      (_ctx.multiVat)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            class: "py-1 pr-1",
                                                            cols: "3"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_oss_text_field_filled, {
                                                                regular: "",
                                                                dense: "",
                                                                "hide-details": true,
                                                                "onUpdate:modelValue": [($event: any) => (
                                                                _ctx.$nextTick(() =>
                                                                    _ctx.onMetadataChange_amountData(
                                                                        subAmount,
                                                                        'vatAmount',
                                                                    ),
                                                                )
                                                            ), ($event: any) => ((subAmount.vatAmount.value) = $event)],
                                                                onMouseover: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.vatAmount,
                                                                    true,
                                                                )
                                                            ),
                                                                onMouseout: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.vatAmount,
                                                                    false,
                                                                )
                                                            ),
                                                                color: 
                                                                _ctx.priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            ,
                                                                modelValue: subAmount.vatAmount.value
                                                              }, {
                                                                label: _withCtx(() => [
                                                                  _createTextVNode(" TVA " + _toDisplayString(index + 1) + " ", 1),
                                                                  (
                                                                        _ctx.confidence(
                                                                            subAmount.vatAmount,
                                                                        )
                                                                    )
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                                        _cache[114] || (_cache[114] = _createTextVNode(" ( ")),
                                                                        _createElementVNode("span", {
                                                                          class: _normalizeClass(
                                                                            _ctx.confidence(
                                                                                subAmount.vatAmount,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        )
                                                                        }, _toDisplayString(`${_ctx.confidence(
                                                                                subAmount.vatAmount,
                                                                            )}%`), 3),
                                                                        _cache[115] || (_cache[115] = _createTextVNode(") "))
                                                                      ]))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onUpdate:modelValue", "onMouseover", "onMouseout", "color", "modelValue"])
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.multiVat)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 1,
                                                            class: "py-1 pr-1",
                                                            cols: "3"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_oss_text_field_filled, {
                                                                regular: "",
                                                                dense: "",
                                                                "hide-details": true,
                                                                "onUpdate:modelValue": [($event: any) => (
                                                                _ctx.$nextTick(() =>
                                                                    _ctx.onMetadataChange_amountData(
                                                                        subAmount,
                                                                        'grossAmount',
                                                                    ),
                                                                )
                                                            ), ($event: any) => ((subAmount.grossAmount.value) = $event)],
                                                                onMouseover: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.grossAmount,
                                                                    true,
                                                                )
                                                            ),
                                                                onMouseout: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.grossAmount,
                                                                    false,
                                                                )
                                                            ),
                                                                color: 
                                                                _ctx.priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            ,
                                                                modelValue: subAmount.grossAmount.value
                                                              }, {
                                                                label: _withCtx(() => [
                                                                  _createTextVNode(" TTC " + _toDisplayString(index + 1) + " ", 1),
                                                                  (
                                                                        _ctx.confidence(
                                                                            subAmount.grossAmount,
                                                                        )
                                                                    )
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                                        _cache[116] || (_cache[116] = _createTextVNode(" ( ")),
                                                                        _createElementVNode("span", {
                                                                          class: _normalizeClass(
                                                                            _ctx.confidence(
                                                                                subAmount.grossAmount,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        )
                                                                        }, _toDisplayString(`${_ctx.confidence(
                                                                                subAmount.grossAmount,
                                                                            )}%`), 3),
                                                                        _cache[117] || (_cache[117] = _createTextVNode(") "))
                                                                      ]))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onUpdate:modelValue", "onMouseover", "onMouseout", "color", "modelValue"])
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.multiVat)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 2,
                                                            class: "py-1 pr-1"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_select_filled, {
                                                                items: 
                                                                subAmount.sign === -1
                                                                    ? _ctx.vatListDiscount
                                                                    : _ctx.vatList
                                                            ,
                                                                regular: "",
                                                                "hide-details": true,
                                                                color: 
                                                                _ctx.priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            ,
                                                                "onUpdate:modelValue": ($event: any) => (
                                                                _ctx.$nextTick(() =>
                                                                    _ctx.onVatRateChange(
                                                                        subAmount,
                                                                        $event,
                                                                    ),
                                                                )
                                                            ),
                                                                onMouseover: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.vatRate,
                                                                    true,
                                                                )
                                                            ),
                                                                onMouseout: ($event: any) => (
                                                                _ctx.highlightField(
                                                                    subAmount.vatRate,
                                                                    false,
                                                                )
                                                            ),
                                                                "model-value": 
                                                                subAmount.vatType
                                                                    ? subAmount.vatRate.value.toString() +
                                                                      subAmount.vatType
                                                                    : subAmount.vatRate.value.toString()
                                                            ,
                                                                density: "compact",
                                                                "item-title": "text"
                                                              }, {
                                                                label: _withCtx(() => [
                                                                  _createTextVNode(" %TVA " + _toDisplayString(index + 1) + " ", 1),
                                                                  (
                                                                        _ctx.confidence(
                                                                            subAmount.vatRate,
                                                                        )
                                                                    )
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                                        _cache[118] || (_cache[118] = _createTextVNode(" (")),
                                                                        _createElementVNode("span", {
                                                                          class: _normalizeClass(
                                                                            _ctx.confidence(
                                                                                subAmount.vatRate,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        )
                                                                        }, _toDisplayString(`${_ctx.confidence(
                                                                                subAmount.vatRate,
                                                                            )}%`), 3),
                                                                        _cache[119] || (_cache[119] = _createTextVNode(") "))
                                                                      ]))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["items", "color", "onUpdate:modelValue", "onMouseover", "onMouseout", "model-value"])
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      (
                                                            _ctx.multiAccountableAccount ||
                                                            subAmount.vatRate.value === 0
                                                        )
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            cols: _ctx.getSubAmountAACol(subAmount),
                                                            class: _normalizeClass(`py-1 order-${_ctx.placementAccountableAccount}`),
                                                            key: _ctx.refreshKeySubAmount
                                                          }, {
                                                            default: _withCtx(() => [
                                                              (_ctx.multiAccountableAccount)
                                                                ? (_openBlock(), _createBlock(_component_AccountableAccountVue, {
                                                                    key: 0,
                                                                    inputStyle: 'padding: 0px; margin: 0px;',
                                                                    inAccountableAccountType: 
                                                                _ctx.getAccountableType(subAmount.type)
                                                            ,
                                                                    companyId: _ctx.companyId,
                                                                    document: _ctx.document,
                                                                    showSuggestion: false,
                                                                    showDescription: true,
                                                                    showValidation: false,
                                                                    mandatory: false,
                                                                    hideDetails: true,
                                                                    editAccountableAccount: true,
                                                                    addInvoiceProduct: _ctx.enableStock,
                                                                    onClose: _ctx.closeAccountableAccount,
                                                                    onSelectAccountableAccount: ($event: any) => (
                                                                _ctx.setSubAmountAccountableAccount(
                                                                    subAmount,
                                                                    $event,
                                                                )
                                                            ),
                                                                    "model-value": 
                                                                subAmount.accountableAccount
                                                            
                                                                  }, null, 8, ["inAccountableAccountType", "companyId", "document", "addInvoiceProduct", "onClose", "onSelectAccountableAccount", "model-value"]))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["cols", "class"]))
                                                        : _createCommentVNode("", true),
                                                      (
                                                            subAmount.stockOperation &&
                                                            subAmount.stockOperation.stockProductId
                                                        )
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 4,
                                                            cols: "4",
                                                            class: _normalizeClass(`py-1 order-${_ctx.placementAccountableAccount}`)
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_oss_text_field_filled, {
                                                                "hide-details": true,
                                                                label: 
                                                                subAmount.stockOperation
                                                                    .quantityName
                                                            ,
                                                                class: "ml-2 righted-input oss-dark",
                                                                modelValue: 
                                                                subAmount.stockOperation
                                                                    .productQuantity
                                                            ,
                                                                "onUpdate:modelValue": ($event: any) => ((
                                                                subAmount.stockOperation
                                                                    .productQuantity
                                                            ) = $event),
                                                                rules: [
                                                                (v) =>
                                                                    v >= 0 ||
                                                                    _ctx.$t('settings.positiveNumber'),
                                                            ]
                                                              }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "rules"])
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["class"]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex align-center justify-center inline-icon flex-column"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.multiVat)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "secondary",
                                                        onClick: ($event: any) => (_ctx.toggleLink(subAmount))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(subAmount.link ? "$link" : "$link_off"), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"]))
                                                    : _createCommentVNode("", true),
                                                  (
                                                        _ctx.form &&
                                                        _ctx.form.subAmounts &&
                                                        _ctx.form.subAmounts.length > 2
                                                    )
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 1,
                                                        color: "secondary",
                                                        onClick: ($event: any) => (_ctx.removeSubAmount(index)),
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[120] || (_cache[120] = [
                                                          _createTextVNode("$oss-trash ")
                                                        ])),
                                                        _: 2
                                                      }, 1032, ["onClick"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                class: "pt-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_divider)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      id: "PricesDocumentValidation"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.subjectToVAT)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              class: "pr-1 py-2",
                                              style: {"z-index":"inherit"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "onUpdate:modelValue": [
                                                    _cache[42] || (_cache[42] = ($event: any) => (
                                                    _ctx.$nextTick(() =>
                                                        _ctx.onMetadataChange_amountData(
                                                            _ctx.form.single_prices.prices,
                                                            'netAmount',
                                                        ),
                                                    )
                                                )),
                                                    _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.single_prices.prices.netAmount.value) = $event))
                                                  ],
                                                  onMouseover: _cache[43] || (_cache[43] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.netAmount,
                                                        true,
                                                    )
                                                )),
                                                  onMouseout: _cache[44] || (_cache[44] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.netAmount,
                                                        false,
                                                    )
                                                )),
                                                  color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                                  readonly: _ctx.multiVat || _ctx.multiAccountableAccount,
                                                  regular: "",
                                                  dense: "",
                                                  "hide-details": true,
                                                  "data-cy": "DocumentValidation-ht",
                                                  modelValue: _ctx.form.single_prices.prices.netAmount.value
                                                }, {
                                                  label: _withCtx(() => [
                                                    _cache[123] || (_cache[123] = _createTextVNode(" HT ")),
                                                    (
                                                            _ctx.confidence(
                                                                _ctx.form.single_prices.prices.netAmount,
                                                            )
                                                        )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                                          _cache[121] || (_cache[121] = _createTextVNode(" (")),
                                                          _createElementVNode("span", {
                                                            class: _normalizeClass(
                                                                _ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .netAmount,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            )
                                                          }, _toDisplayString(`${_ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .netAmount,
                                                                )}%`), 3),
                                                          _cache[122] || (_cache[122] = _createTextVNode(") "))
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }, 8, ["color", "readonly", "modelValue"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.subjectToVAT)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 1,
                                              class: "px-1 py-2",
                                              style: {"z-index":"inherit"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "onUpdate:modelValue": [
                                                    _cache[46] || (_cache[46] = ($event: any) => (
                                                    _ctx.$nextTick(() =>
                                                        _ctx.onMetadataChange_amountData(
                                                            _ctx.form.single_prices.prices,
                                                            'vatAmount',
                                                        ),
                                                    )
                                                )),
                                                    _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.single_prices.prices.vatAmount.value) = $event))
                                                  ],
                                                  onMouseover: _cache[47] || (_cache[47] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatAmount,
                                                        true,
                                                    )
                                                )),
                                                  onMouseout: _cache[48] || (_cache[48] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatAmount,
                                                        false,
                                                    )
                                                )),
                                                  color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                                  readonly: _ctx.multiVat,
                                                  regular: "",
                                                  dense: "",
                                                  "hide-details": true,
                                                  "data-cy": "DocumentValidation-tva",
                                                  modelValue: _ctx.form.single_prices.prices.vatAmount.value
                                                }, {
                                                  label: _withCtx(() => [
                                                    _cache[126] || (_cache[126] = _createTextVNode(" TVA ")),
                                                    (
                                                            _ctx.confidence(
                                                                _ctx.form.single_prices.prices.vatAmount,
                                                            )
                                                        )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                                          _cache[124] || (_cache[124] = _createTextVNode(" (")),
                                                          _createElementVNode("span", {
                                                            class: _normalizeClass(
                                                                _ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .vatAmount,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            )
                                                          }, _toDisplayString(`${_ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .vatAmount,
                                                                )}%`), 3),
                                                          _cache[125] || (_cache[125] = _createTextVNode(") "))
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }, 8, ["color", "readonly", "modelValue"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, {
                                          class: "px-1 py-2",
                                          style: {"z-index":"inherit"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_oss_text_field_filled, {
                                              "onUpdate:modelValue": [
                                                _cache[50] || (_cache[50] = ($event: any) => (
                                                    _ctx.$nextTick(() =>
                                                        _ctx.onMetadataChange_amountData(
                                                            _ctx.form.single_prices.prices,
                                                            'grossAmount',
                                                        ),
                                                    )
                                                )),
                                                _cache[53] || (_cache[53] = ($event: any) => ((
                                                    _ctx.form.single_prices.prices.grossAmount.value
                                                ) = $event))
                                              ],
                                              onMouseover: _cache[51] || (_cache[51] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.grossAmount,
                                                        true,
                                                    )
                                                )),
                                              onMouseout: _cache[52] || (_cache[52] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.grossAmount,
                                                        false,
                                                    )
                                                )),
                                              color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                              readonly: _ctx.multiVat,
                                              regular: "",
                                              dense: "",
                                              "hide-details": true,
                                              "data-cy": "DocumentValidation-ttc",
                                              modelValue: 
                                                    _ctx.form.single_prices.prices.grossAmount.value
                                                
                                            }, {
                                              label: _withCtx(() => [
                                                _cache[129] || (_cache[129] = _createTextVNode(" TTC ")),
                                                (
                                                            _ctx.confidence(
                                                                _ctx.form.single_prices.prices
                                                                    .grossAmount,
                                                            )
                                                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                                      _cache[127] || (_cache[127] = _createTextVNode(" (")),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(
                                                                _ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .grossAmount,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            )
                                                      }, _toDisplayString(`${_ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .grossAmount,
                                                                )}%`), 3),
                                                      _cache[128] || (_cache[128] = _createTextVNode(") "))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }, 8, ["color", "readonly", "modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.subjectToVAT)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 2,
                                              class: "px-1 py-2",
                                              style: {"z-index":"inherit"}
                                            }, {
                                              default: _withCtx(() => [
                                                _withDirectives(_createVNode(_component_v_select_filled, {
                                                  items: _ctx.vatList,
                                                  regular: "",
                                                  "hide-details": true,
                                                  "item-title": "text",
                                                  color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (
                                                    _ctx.$nextTick(() =>
                                                        _ctx.onVatRateChange(
                                                            _ctx.form.single_prices.prices,
                                                            $event,
                                                        ),
                                                    )
                                                )),
                                                  onMouseover: _cache[55] || (_cache[55] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatRate,
                                                        true,
                                                    )
                                                )),
                                                  onMouseout: _cache[56] || (_cache[56] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatRate,
                                                        false,
                                                    )
                                                )),
                                                  "data-cy": "DocumentValidation-tvaPercentage",
                                                  "model-value": 
                                                    _ctx.form.single_prices.prices.vatType
                                                        ? _ctx.form.single_prices.prices.vatRate.value.toString() +
                                                          _ctx.form.single_prices.prices.vatType
                                                        : _ctx.form.single_prices.prices.vatRate.value.toString()
                                                
                                                }, {
                                                  label: _withCtx(() => [
                                                    _cache[132] || (_cache[132] = _createTextVNode(" %TVA ")),
                                                    (
                                                            _ctx.confidence(
                                                                _ctx.form.single_prices.prices.vatRate,
                                                            )
                                                        )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                                          _cache[130] || (_cache[130] = _createTextVNode(" (")),
                                                          _createElementVNode("span", {
                                                            class: _normalizeClass(
                                                                _ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .vatRate,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            )
                                                          }, _toDisplayString(`${_ctx.confidence(
                                                                    _ctx.form.single_prices.prices
                                                                        .vatRate,
                                                                )}%`), 3),
                                                          _cache[131] || (_cache[131] = _createTextVNode(") "))
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }, 8, ["items", "color", "model-value"]), [
                                                  [_vShow, !_ctx.multiVat]
                                                ])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, {
                                          cols: "1",
                                          class: "pa-0 py-2 d-flex align-center justify-center",
                                          style: {"z-index":"inherit"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_24, [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: 
                                                        _ctx.form.allPricesValidated
                                                            ? '$oss-circle-check'
                                                            : '$oss-circle-uncheck'
                                                    ,
                                                onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.onPricesValidation())),
                                                color: 
                                                        _ctx.form.allPricesValidated ? 'primary' : 'red'
                                                    ,
                                                "data-cy": "DocumentValidation-valid",
                                                size: "small"
                                              }, null, 8, ["icon", "color"]),
                                              (!_ctx.multiVat)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    color: "secondary",
                                                    onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.toggleLink(_ctx.form.single_prices.prices)))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.form.single_prices.prices.link
                                                            ? "$link"
                                                            : "$link_off"), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.showDeposit)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 3,
                                          "no-gutters": "",
                                          class: "flex-nowrap"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "pl-1 d-flex align-center flex-grow-1 flex-shrink-0",
                                              style: {"max-width":"100%"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_switch, {
                                                  modelValue: _ctx.withDeposit,
                                                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.withDeposit) = $event)),
                                                  label: 'Consigne',
                                                  "hide-details": "",
                                                  class: "my-0 ml-2",
                                                  "data-cy": "DocumentValidation-order"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "7",
                                              class: "d-flex align-center flex-grow-0 flex-shrink-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.showDeposit && _ctx.withDeposit)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 4,
                                          "no-gutters": "",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "4",
                                              class: "pa-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  modelValue: _ctx.deposit.amountSigned1,
                                                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.deposit.amountSigned1) = $event)),
                                                  label: "Consigne",
                                                  regular: "",
                                                  dense: ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "4",
                                              class: "pa-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  modelValue: _ctx.deposit.amountSigned2,
                                                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.deposit.amountSigned2) = $event)),
                                                  label: "Déconsigne",
                                                  regular: "",
                                                  dense: ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "4",
                                              class: "pa-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  label: "TTC",
                                                  regular: "",
                                                  dense: "",
                                                  "content-class": "mr-1",
                                                  suffix: "€",
                                                  "hide-details": "",
                                                  readonly: "",
                                                  "model-value": _ctx.depositGrossAmountSigned
                                                }, null, 8, ["model-value"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (
                                            !_ctx.isBankTransactionReceipt &&
                                            _ctx.document &&
                                            _ctx.document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 5,
                                          "no-gutters": "",
                                          class: "flex-nowrap py-2 pt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "7",
                                              class: "pl-1 d-flex align-center flex-grow-1 flex-shrink-0",
                                              style: {"max-width":"100%"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_switch, {
                                                  modelValue: _ctx.withSubGrossAmounts,
                                                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.withSubGrossAmounts) = $event)),
                                                  label: 
                                                    _ctx.isAccountingUser
                                                        ? 'Payer en plusieurs fois / * comptes de tiers'
                                                        : 'Payer en plusieurs fois'
                                                ,
                                                  class: "py-0 my-0 pl-2",
                                                  onChange: _cache[63] || (_cache[63] = ($event: any) => (_ctx.onActiveSubGrossAmount())),
                                                  "hide-details": "",
                                                  "data-cy": "DocumentValidation-pay"
                                                }, null, 8, ["modelValue", "label"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex align-center flex-grow-0 flex-shrink-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.withSubGrossAmounts)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  class: "justify-end align-center flex-grow-0 flex-shrink-1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      size: "x-small",
                                                      onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.addNewSubGrossAmount())),
                                                      "date-cy": "DocumentValidation-add",
                                                      icon: "$add"
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.withSubGrossAmounts)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 6,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.subGrossAmounts, (subGrossAmount, index) => {
                                                  return (_openBlock(), _createBlock(_component_v_row, {
                                                    "no-gutters": "",
                                                    key: index
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { class: "mb-1" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_text_field_filled, {
                                                            modelValue: subGrossAmount.amount,
                                                            "onUpdate:modelValue": ($event: any) => ((subGrossAmount.amount) = $event),
                                                            label: "Montant",
                                                            regular: "",
                                                            "content-class": "mr-1",
                                                            "hide-details": ""
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      (_ctx.isAccountingUser)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            cols: "5",
                                                            class: "mb-1 pl-1"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_AccountableAccountVue, {
                                                                inputStyle: 'padding: 0px; margin: 0px;',
                                                                companyId: _ctx.companyId,
                                                                showSuggestion: false,
                                                                showDescription: true,
                                                                showValidation: false,
                                                                mandatory: false,
                                                                hideDetails: true,
                                                                needValidation: false,
                                                                editAccountableAccount: true,
                                                                excludesAccountableAccount: [
                                                            '421000',
                                                            '425000',
                                                            '455000',
                                                            '455100',
                                                            '467000',
                                                            '467100',
                                                        ],
                                                                onClose: _ctx.closeAccountableAccount,
                                                                onSelectAccountableAccount: ($event: any) => (
                                                            _ctx.setAccountableAccountSubGrossAmount(
                                                                subGrossAmount,
                                                                $event,
                                                            )
                                                        ),
                                                                "model-value": 
                                                            subGrossAmount.accountableAccount
                                                        
                                                              }, null, 8, ["companyId", "onClose", "onSelectAccountableAccount", "model-value"])
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      _createVNode(_component_v_col, {
                                                        cols: "4",
                                                        class: "pl-1 mb-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_date_picker_filled, {
                                                            modelValue: subGrossAmount.dueDate,
                                                            "onUpdate:modelValue": ($event: any) => ((subGrossAmount.dueDate) = $event),
                                                            label: "Échéance",
                                                            textFieldReadOnly: false,
                                                            notRequired: true
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, {
                                                        cols: "1",
                                                        class: "d-flex align-center justify-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.form.subGrossAmounts.length > 1)
                                                            ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                                key: 0,
                                                                onClick: ($event: any) => (_ctx.removeSubGrossAmount(index)),
                                                                "data-cy": "DocumentValidation-trash",
                                                                size: "small"
                                                              }, null, 8, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.showAudit)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 7,
                                          "no-gutters": "",
                                          class: "py-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "1",
                                              class: "d-flex align-center flex-grow-1 flex-shrink-0",
                                              style: {"max-width":"100%"}
                                            }, {
                                              default: _withCtx(() => _cache[133] || (_cache[133] = [
                                                _createTextVNode(" Révision comptable ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "11",
                                              class: "d-flex align-center flex-grow-0 flex-shrink-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            (
                                                _ctx.tooltipDocumentAdjustmentBtn ===
                                                'Exercice comptable clôturé'
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "auto",
                                                  class: "px-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.tooltipDocumentAdjustmentBtn), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.showAudit)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 8,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DocumentAuditActions, {
                                                  companyId: _ctx.companyId,
                                                  document: _ctx.document,
                                                  documentId: _ctx.document.id,
                                                  documentAccountingPeriod: _ctx.documentAccountingPeriod,
                                                  onGoToWindowStep10: _ctx.openWindowStep10,
                                                  onGoToWindowStep0: _ctx.setWindowStep
                                                }, null, 8, ["companyId", "document", "documentId", "documentAccountingPeriod", "onGoToWindowStep10", "onGoToWindowStep0"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.enableStock)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 9,
                                          "no-gutters": "",
                                          class: "py-2 pt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "1",
                                              class: "pl-1 d-flex align-center pr-3 flex-grow-1 flex-shrink-0",
                                              style: {"max-width":"100%"}
                                            }, {
                                              default: _withCtx(() => _cache[134] || (_cache[134] = [
                                                _createTextVNode(" Stocks ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "11",
                                              class: "d-flex align-center flex-grow-0 flex-shrink-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.enableStock)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 10,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "py-1 mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card, {
                                                  class: "default_card_wm mx-auto pt-2",
                                                  style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card_title, {
                                                      "primary-title": "",
                                                      class: "py-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "auto",
                                                              class: "pr-2"
                                                            }, {
                                                              default: _withCtx(() => _cache[135] || (_cache[135] = [
                                                                _createElementVNode("span", null, " Opérations de stock ", -1)
                                                              ])),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_spacer),
                                                            _createVNode(_component_v_col, {
                                                              cols: "auto",
                                                              class: "d-flex justify-end"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                                  activator: _withCtx(({ props }) => [
                                                                    _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                                                      _createVNode(_component_v_btn_icon, {
                                                                        icon: "$oss-edit",
                                                                        elevation: "0",
                                                                        class: "my-0",
                                                                        onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.windowStep = 11)),
                                                                        size: "x-small"
                                                                      })
                                                                    ], 16)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (!_ctx.accountingLinesLocked && _ctx.showDetail)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 11,
                                          "no-gutters": "",
                                          class: "pt-1 pb-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "py-2 align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "pl-1 pr-3 flex-grow-1 flex-shrink-0",
                                                      style: {"max-width":"100%"}
                                                    }, {
                                                      default: _withCtx(() => _cache[136] || (_cache[136] = [
                                                        _createTextVNode(" Détails ")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "11",
                                                      class: "pr-3 flex-grow-0 flex-shrink-1"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_divider)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "py-2 mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_accounting_item_static, {
                                                  companyId: _ctx.companyId,
                                                  documentId: _ctx.document.id,
                                                  onUpdate: _ctx.startToBeDoneIfNecessary,
                                                  mode: "Payment"
                                                }, null, 8, ["companyId", "documentId", "onUpdate"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_back, {
                                      onClick: _cache[67] || (_cache[67] = _withModifiers(($event: any) => (_ctx.windowStep = 0), ["stop"]))
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CompaniesTable, {
                                      showGenericCompany: _ctx.document.type !== 'SALES_INVOICE',
                                      showCustomerCompanies: 
                                                _ctx.document.type === 'SALES_INVOICE'
                                            ,
                                      showSupplierCompanies: 
                                                _ctx.document.type !== 'SALES_INVOICE'
                                            ,
                                      foundCompanies: _ctx.foundCompanies,
                                      showExistingCompanies: false,
                                      company: 
                                                _ctx.document.thirdPartyCompany
                                                    ? _ctx.document.thirdPartyCompany.name
                                                    : ''
                                            ,
                                      siret: 
                                                _ctx.document.thirdPartyCompany &&
                                                _ctx.document.thirdPartyCompany.siret
                                                    ? _ctx.document.thirdPartyCompany.siret
                                                    : ''
                                            ,
                                      siren: 
                                                _ctx.document.thirdPartyCompany &&
                                                _ctx.document.thirdPartyCompany.siren
                                                    ? _ctx.document.thirdPartyCompany.siren
                                                    : ''
                                            ,
                                      vatNumber: 
                                                _ctx.document.thirdPartyCompany &&
                                                _ctx.document.thirdPartyCompany.vatNumber
                                                    ? _ctx.document.thirdPartyCompany.vatNumber
                                                    : ''
                                            ,
                                      parentCompanyId: 
                                                _ctx.selectedCompany ? _ctx.selectedCompany.id : ''
                                            ,
                                      wizardMode: true,
                                      canSelectInactiveCompanies: true,
                                      listHeight: "calc(100vh - 315px)",
                                      onSelectCompany: _ctx._companySelected
                                    }, null, 8, ["showGenericCompany", "showCustomerCompanies", "showSupplierCompanies", "foundCompanies", "company", "siret", "siren", "vatNumber", "parentCompanyId", "onSelectCompany"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 10 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                (_ctx.auditChildren === 'DocumentAdjustments')
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DocumentAdjustments, {
                                          companyId: _ctx.companyId,
                                          thirdPartyCompany: 
                                                _ctx.document.thirdPartyCompany
                                                    ? _ctx.document.thirdPartyCompany
                                                    : ''
                                            ,
                                          document: _ctx.document,
                                          documentAcrStatus: _ctx.documentAcrStatus,
                                          documentAccountingPeriod: 
                                                _ctx.documentAccountingPeriod || undefined
                                            ,
                                          acKey: _ctx.adjustmentAcKey,
                                          onBack: _cache[68] || (_cache[68] = ($event: any) => (_ctx.windowStep = 0))
                                        }, null, 8, ["companyId", "thirdPartyCompany", "document", "documentAcrStatus", "documentAccountingPeriod", "acKey"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 11 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                true
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.windowStep === 11)
                                          ? (_openBlock(), _createBlock(_component_StockOperationDocumentEdition, {
                                              key: 0,
                                              class: "pa-0 ma-0",
                                              companyId: _ctx.companyId,
                                              documentId: _ctx.documentId,
                                              document: _ctx.document,
                                              onBack: _cache[69] || (_cache[69] = ($event: any) => (_ctx.windowStep = 0))
                                            }, null, 8, ["companyId", "documentId", "document"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.windowStep === 0)
                  ? (_openBlock(), _createBlock(_component_v_card_actions, {
                      key: 0,
                      class: "align-self-end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          style: {"min-height":"32px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: _normalizeClass({
                                    'd-flex': true,
                                    'justify-end': true,
                                    'align-center': true,
                                    'pr-15': _ctx.openChat,
                                })
                            }, {
                              default: _withCtx(() => [
                                (_ctx.selectedCompany.solution !== 'MANAGEMENT')
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      location: "top"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps({
                                          onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.setToReuploadDocumentDialog = true)),
                                          class: "mr-1",
                                          disabled: _ctx.document.status === 'VALIDATED',
                                          "data-cy": "DocumentValidation-documentPendingBTN"
                                        }, props, {
                                          icon: "$hourglass_empty",
                                          variant: "flat",
                                          size: "x-small"
                                        }), null, 16, ["disabled"])
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[137] || (_cache[137] = _createElementVNode("span", null, "Document en attente", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_oss_dialog, {
                                  modelValue: _ctx.setToReuploadDocumentDialog,
                                  "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.setToReuploadDocumentDialog) = $event)),
                                  title: "Passer en attente",
                                  onValid: _cache[73] || (_cache[73] = ($event: any) => (_ctx.setToReuploadDocument())),
                                  prefixDataCy: "DocumentValidation-documentPending",
                                  width: "800px"
                                }, {
                                  default: _withCtx(() => _cache[138] || (_cache[138] = [
                                    _createElementVNode("div", { class: "text-center" }, "Passer ce document en attente", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (_ctx.selectedCompany.solution !== 'MANAGEMENT')
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 1,
                                      location: "top"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn_warning, _mergeProps({
                                          onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.setOpenChat('DENIED'))),
                                          class: "mr-1",
                                          disabled: _ctx.document.status === 'DENIED',
                                          "data-cy": "DocumentValidation-reject"
                                        }, props, {
                                          variant: "flat",
                                          size: "x-small"
                                        }), null, 16, ["disabled"])
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[139] || (_cache[139] = _createElementVNode("span", null, "Rejeter", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedCompany.solution !== 'MANAGEMENT')
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 2,
                                      location: "top"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps({
                                          onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.setOpenChat('INFORMATION_REQUEST'))),
                                          class: "mx-1",
                                          "data-cy": "DocumentValidation-question"
                                        }, props, {
                                          icon: "$oss-chat",
                                          variant: "flat",
                                          size: "x-small"
                                        }), null, 16)
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[140] || (_cache[140] = _createElementVNode("span", null, "Question", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.displayDocumentValidationSpeedRun(_ctx.document.status))
                                  ? (_openBlock(), _createBlock(_component_DocumentValidationSpeedRun, {
                                      key: 3,
                                      modelValue: _ctx.lastDocumentValidationDone,
                                      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.lastDocumentValidationDone) = $event))
                                    }, null, 8, ["modelValue"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_component_v_btn, {
                                    class: "ml-1",
                                    onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.onCheckFormValidation())),
                                    loading: _ctx.loading,
                                    "data-cy": "DocumentValidation-valider",
                                    size: "small",
                                    variant: "flat",
                                    disabled: _ctx.disabledValidate || _ctx.doublonLoading
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.validated ? "Validé" : "Valider") + " ", 1),
                                      _withDirectives(_createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[141] || (_cache[141] = [
                                          _createTextVNode("$check")
                                        ])),
                                        _: 1
                                      }, 512), [
                                        [_vShow, _ctx.validated]
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "disabled"])
                                ]),
                                (_ctx.mode != 'GeneralLedger' && _ctx.mode !== 'Reconciliation')
                                  ? (_openBlock(), _createBlock(_component_v_btn_prev, {
                                      key: 4,
                                      disabled: _ctx.previousDisabled(),
                                      onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.previous()))
                                    }, null, 8, ["disabled"]))
                                  : _createCommentVNode("", true),
                                (_ctx.mode != 'GeneralLedger' && _ctx.mode !== 'Reconciliation')
                                  ? (_openBlock(), _createBlock(_component_v_btn_next, {
                                      key: 5,
                                      disabled: _ctx.nextDisabled(),
                                      onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.next()))
                                    }, null, 8, ["disabled"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    }),
    _createVNode(_component_oss_date_picker, {
      hideActivator: true,
      activate: _ctx.dateDialog,
      onClose: _cache[80] || (_cache[80] = ($event: any) => (_ctx.closeDateDialog())),
      modelValue: _ctx.date,
      "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.date) = $event))
    }, null, 8, ["activate", "modelValue"]),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 0,
          id: _ctx.document.chat ? _ctx.document.chat.id : '',
          inShowMessage: _ctx.open_chat,
          chatTitle: 'Document',
          chatSubtitle: _ctx.getChatSubTitle(),
          showSmartChat: _ctx.wishStatus !== 'DENIED',
          onMessageSent: _cache[82] || (_cache[82] = ($event: any) => (_ctx.onMessageSent($event))),
          onShowMessageChanged: _cache[83] || (_cache[83] = ($event: any) => (_ctx.onShowMessageChanged($event)))
        }, null, 8, ["id", "inShowMessage", "chatSubtitle", "showSmartChat"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogChooseDownload,
      "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
      title: "Télécharger le document",
      width: "800px"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.downloadFile(true))),
                  id: "DownloadOriginalDocumentValidation",
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[142] || (_cache[142] = [
                    _createTextVNode("Original")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.downloadFile(false))),
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[143] || (_cache[143] = [
                    _createTextVNode("Marqué")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[144] || (_cache[144] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté) ? "))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogSwitchToMiscellaneous,
      "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.dialogSwitchToMiscellaneous) = $event)),
      title: "Passer le document en divers",
      onValid: _ctx.switchToMiscellaneous,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[145] || (_cache[145] = [
        _createElementVNode("h4", null, " Si vous confirmez l'action, toutes les données comptables associés aux documents seront supprimées ", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.analyseDocumentDialog,
      "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
      title: "Relancer l'analyse du document",
      onValid: _ctx.analyseDocument,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[146] || (_cache[146] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir relancer l'analyse ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.accountingLinesLockedDialog,
      "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.accountingLinesLockedDialog) = $event)),
      title: "Passer en écriture manuelle",
      onValid: _ctx.lockAccountingLines,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.accountingLinesLockedLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[147] || (_cache[147] = [
        _createElementVNode("h4", null, " Si vous confirmez l'action, vous pourrez modifier les écritures manuellement mais vous perdez les automatismes ", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    (_ctx.orphelinDepreciationAcrId && _ctx.orphelinDepreciationAcrId.length)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 1,
          modelValue: _ctx.deleteOrphelinDocumentDialog,
          "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.deleteOrphelinDocumentDialog) = $event)),
          title: "Supprimer le contrôle orphelin",
          error: true,
          onValid: _cache[91] || (_cache[91] = ($event: any) => (_ctx.deleteAuditCheckResult(_ctx.orphelinDepreciationAcrId))),
          validTitle: 'Valider la suppression des amortissements automatiques',
          validLoading: _ctx.deleteOrphelinDocumentLoading,
          width: "800px"
        }, {
          default: _withCtx(() => [
            (_ctx.editionMessage && _ctx.editionMessage.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: _ctx.editionMessage
                }, null, 8, _hoisted_27))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "validLoading"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => [
        (_ctx.editionMessage && _ctx.editionMessage.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.editionMessage
            }, null, 8, _hoisted_28))
          : _createCommentVNode("", true),
        _cache[148] || (_cache[148] = _createElementVNode("h4", { class: "pb-4" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1))
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.spreadPurchaseDialog,
      "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.spreadPurchaseDialog) = $event)),
      title: "Etaler le montant sur plusieurs mois",
      onValid: _ctx.spreadAmount,
      validLoading: _ctx.loading,
      validDisabled: !_ctx.spreadValid,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: _ctx.spreadValid,
          "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.spreadValid) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => _cache[149] || (_cache[149] = [
                    _createTextVNode(" Pour les charges supérieures à 1000 euros vous pouvez répartir le montant sur plusieurs mois ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      modelValue: _ctx.activateSpreadAmount,
                      "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.activateSpreadAmount) = $event)),
                      label: "Etaler"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_date_picker, {
                      label: _ctx.$t('shared.spreadStartDate'),
                      modelValue: _ctx.spreadStartDate,
                      "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.spreadStartDate) = $event)),
                      minDate: _ctx.spreadMinStartDate,
                      maxDate: _ctx.spreadMaxStartDate,
                      type: 'month',
                      format: 'MM/YYYY'
                    }, null, 8, ["label", "modelValue", "minDate", "maxDate"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.activateSpreadAmount]
                ]),
                _withDirectives(_createVNode(_component_v_col, {
                  cols: "12",
                  "mt-4": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_slider, {
                      modelValue: _ctx.spreadMounthCount,
                      "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.spreadMounthCount) = $event)),
                      "thumb-size": 24,
                      "thumb-label": "always",
                      label: "Nombre de mois",
                      min: "2",
                      max: "12",
                      "show-ticks": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.activateSpreadAmount]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading", "validDisabled"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.cutDocumentDialog,
      "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.cutDocumentDialog) = $event)),
      title: "Découpe de document",
      onValid: _cache[99] || (_cache[99] = ($event: any) => (_ctx.cutDocument())),
      width: "800px"
    }, {
      default: _withCtx(() => _cache[150] || (_cache[150] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir découper ce document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.confirmDoublonDialog,
      "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.confirmDoublonDialog) = $event)),
      title: "Confirmez la validation",
      onValid: _cache[101] || (_cache[101] = ($event: any) => (_ctx.onFormValidation())),
      prefixDataCy: "DocumentValidation-documentPending",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, " Il existe déjà une facture avec le même montant à la même date pour le même " + _toDisplayString(_ctx.document.type === "PURCHASE_INVOCE" ? "fournisseur" : "client"), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}